































































import Vue from 'vue';
import NoteModal from '@/web/components/customers/NoteModal.vue';
import HMDialog from '@/web/components/common/HMDialog.vue';

export default Vue.extend({
  name: 'CustomerDetailNotes',
  components: {},
  computed: {
    getUserId() {
      return parseInt(this.$route.params.id);
    },
    customerNotesQuery() {
      return {
        customerId: this.getUserId,
      };
    },
  },
  data() {
    return {
      customerNotesFields: [
        {
          name: 'title',
          title: this.$t('CUSTOMERS.TABLE.TITLE'),
          cssClass: 'h5',
        },
        /*
        {
          name: 'note',
          title: this.$t('CUSTOMERS.TABLE.NOTE'),
          cssClass: 'c-charcoal',
        },
        */
        {
          name: 'updated',
          title: this.$t('GENERAL.LABEL.UPDATED'),
        },
        {
          name: 'edit',
          cssClass: 'table-button',
        },
        {
          name: 'delete',
          cssClass: 'table-button',
        },
      ],
      addingCustomerNote: false,
    };
  },
  methods: {
    async addCustomerNote() {
      this.addingCustomerNote = true;

      try {
        const newCustomerNote = await this.$store.dispatch(
          'sale/addCustomerNote',
          {
            customerId: this.getUserId,
            noteData: { note: '', title: '' },
          }
        );
        this.editCustomerNote(newCustomerNote);
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
          text: this.$t('CUSTOMERS.TEXT.NOTE_CREATE_ERROR'),
        });
      }
      this.addingCustomerNote = false;
    },
    editCustomerNote(customerNote) {
      const params = {
        customerId: this.getUserId,
        id: customerNote.id,
      };
      this.$router.push({ name: 'CustomerEditNote', params });
    },
    openCustomerNote(customerNote) {
      this.$modal.show(
        NoteModal,
        {
          note: customerNote,
          customerId: this.getUserId,
        },
        {
          classes: ['vm--inline-modal'],
        }
      );
    },
    async deleteCustomerNote(noteId) {
      this.$modal.show(HMDialog, {
        title: this.$t('CUSTOMERS.LABEL.DELETE_NOTE'),
        text: this.$t('CUSTOMERS.TEXT.ARE_YOU_SURE_YOU_WANT_TO_DELETE'),
        confirmButton: this.$t('CUSTOMERS.LABEL.DELETE_NOTE'),
        confirm: async () => {
          try {
            await this.$store.dispatch('sale/deleteCustomerNote', {
              noteId,
              customerId: this.getUserId,
            });
            await this.$refs['customer-notes-table'].refresh();
          } catch (error) {
            this.$notify({
              group: 'app',
              type: 'error',
              title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
              text: this.$t('CUSTOMERS.TEXT.NOTE_DELETE_ERROR'),
            });
          }
        },
        discard: () => {},
      });
    },
  },
});
